<template>
  <div class="event-search">
    <SearchRefiners
      :results="results"
      :selectedFacetOptions="selectedFacetOptions"
      @applyFilters="onApplyFilters"
      @resetFilters="onResetFilters"
    >
      <template #custom-filters>
        <div class="result-facet past-events">
          <ul>
            <FacetOption :label="labels.pastEvents" :on-change="onTogglePastEvents" :checked="showPastEvents"></FacetOption>
          </ul>
        </div>
      </template>
    </SearchRefiners>
    <div class="grid-container">
      <div class="event grid-xl-12 grid-sm-12" v-if="results.rows.length > 0">
        <div v-for="event in results.rows" class="event-entry" :key="event.id" itemscope
          itemtype="http://schema.org/Event">
          <meta itemprop="startDate" :content="event.dateFrom.replace('Z', event.timezone)">
          <meta itemprop="endDate" :content="event.dateTo.replace('Z', event.timezone)">
          <meta itemprop="location"
            :content="event.type === 'General Event' ? `${event.town} ${event.country}` : labels.onlineEvent">
          <meta itemprop="eventAttendanceMode"
            :content="event.type === 'General Event' ? 'https://schema.org/OfflineEventAttendanceMode' : 'https://schema.org/OnlineEventAttendanceMode'">
          <meta itemprop="image" :content="event.imageUrl">
          <meta itemprop="organizer" content="Clariant">
          <meta itemprop="performer" content="Clariant">
          <div class="event-coords desktop">
            <div class="event-dates" :class="{ differentmonth: getMonth(event.dateFrom) !== getMonth(event.dateTo) }">
              <span v-if="isSameDate(event.dateFrom, event.dateTo)">{{ getMonth(event.dateFrom) }} {{
                getDay(event.dateFrom) }}, {{ getYear(event.dateFrom) }}</span>
              <span v-else>
                <span>{{ getMonth(event.dateFrom) }}</span>
                <span>&nbsp;{{ getDay(event.dateFrom) }}</span>
                <span v-if="getYear(event.dateFrom) !== getYear(event.dateTo)">, {{ getYear(event.dateFrom) }}</span>
                <span> &ndash; </span>
                <span v-if="getMonth(event.dateFrom) !== getMonth(event.dateTo)">{{ getMonth(event.dateTo) }}&nbsp;</span>
                <span>{{ getDay(event.dateTo) }}</span>
                <span>, {{ getYear(event.dateTo) }}</span>
              </span>
              <!--<div class="event-months">
                <span class="event-month">{{ getMonth(event.dateFrom) }}</span>
                <span class="event-date-separator">&nbsp;</span>
                <span class="event-month tomonth">{{ getMonth(event.dateTo) }}</span>
              </div>
              <div class="event-days">
                <div class="event-day">{{ getDay(event.dateFrom) }}</div>
                <div class="event-date-separator" v-if="!isSameDate(event.dateFrom, event.dateTo)">-</div>
                <div class="event-day" v-if="!isSameDate(event.dateFrom, event.dateTo)">{{ getDay(event.dateTo) }}</div>
              </div>
              <div class="event-years">
                <div class="event-year">{{ getYear(event.dateFrom) }}</div>
                <div class="event-date-separator">&nbsp;</div>
                <div class="event-year" v-if="getYear(event.dateFrom) !== getYear(event.dateTo)">{{ getYear(event.dateTo) }}
                </div>
              </div>---->
            </div>
            <div class="download-ics" :title="labels.downloadIcs" @click="downloadIcs(event)"></div>
          </div>
          <div class="event-details" :class="{ emptycontent: !event.hasText }">
            <meta itemprop="url" :content="event.url" />
            <div class="event-image" v-if="event.imageUrl" :style="{ backgroundImage: 'url(' + event.imageUrl + ')' }"
              @click="onEventClick(event)" role="img" :aria-label="event.title">
            </div>
            <div>
              <div class="event-town" v-if="event.type === 'General Event'">{{ event.town }} {{ event.country }}</div>
              <div class="event-town" v-if="event.type === 'Webinar'">{{ labels.webinar }}</div>
              <div class="event-town" v-if="event.type === 'Bizzabo Event'">{{ labels.bizzaboEventLocation }}</div>
              <div class="event-title" itemprop="name" @click="onEventClick(event)">{{ event.title }}</div>
              <div class="event-coords tablet">
                <div class="event-date">{{ formatDate(event.dateFrom) }} {{ isSameDate(event.dateFrom, event.dateTo) ? ""
                  : " - " + formatDate(event.dateTo) }}</div>
                <div class="download-ics" :title="labels.downloadIcs" @click="downloadIcs(event)"></div>
              </div>
              <div class="event-description" v-if="event.description || event.hasText"><span v-html="event.description"
                  itemprop="description" @click="onEventClick(event)"></span>&nbsp;

              </div>
            </div>
          </div>
          <div class="event-arrow">
            <a v-if="event.hasText" :title="event.title" :href="event.url"></a>
          </div>
        </div>
        <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
      </div>
      <div class="no-items grid-xl-12 grid-sm-12" v-if="results.rows.length == 0 && !isLoading">{{ labels.noItemsFound }}</div>
      <div class="please-wait" v-if="isLoading">
        <img src="../assets/pic_loading.gif" />
      </div>
    </div>
    <div class="result-facet past-events" v-if="results.rows.length == 0">
      <ul>
        <FacetOption :label="labels.pastEvents" :on-change="onTogglePastEvents" :checked="showPastEvents"></FacetOption>
      </ul>
    </div>
  </div>
</template>

<script>
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import { SessionState } from './services/session-state.js'
import SearchRefiners from './ui/SearchRefiners.vue'

export default {
  name: 'EventSearch',
  components: {
    Facet,
    FacetOption,
    Pager,
    SearchRefiners
  },
  props: {
    resultCount: String
  },
  data() {
    return {
      labels: Labels,
      isLoading: false,
      currentQuery: "",
      results: {
        rows: [],
        facets: []
      },
      tags: "",
      showPastEvents: Settings.showPastEvents,
      collapsedFacets: Settings.events.collapsedFacets,
      selectedFacetOptions: [],
      isFirstQuery: true,
      hiddenFacets: Settings.hiddenFacets
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("events", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }

    var pastevents = SessionState.get("events", "past_events");
    if (pastevents) {
      this.showPastEvents = (pastevents === "1");
    }
  },
  methods: {
    onEventClick(event) {
      if (!event) return;
      if (event.hasText) window.open(event.url, "_self");
    },
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    search(filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      console.log("Searching for events with " + filters.query)
      oThis.isLoading = true;
      if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("events", "facets", null);
      }
      this.isFirstQuery = false;
      var url = Utils.constructNewQueryUrl("events", filters.query, this.selectedFacetOptions);
      if (this.showPastEvents) {
        url += "&pastEvents=1";
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results);
        if (oThis.tags.length > 0) {
          oThis.selectTagsInFacets();
        }
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        Utils.applyVisualUpdates(".event-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("Events Search", filters.query, oThis.results.totalRows);
        }
      }).catch(function (err) {
        console.error("Error loading events: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        oThis.isLoading = false;
      });

    },
    onShowMore() {
      var oThis = this;
      if (oThis.isLoading) return;
      console.log("Searching for more events with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("events", this.currentQuery, oThis.results, oThis.selectedFacetOptions);
      if (this.showPastEvents) {
        url += "&pastEvents=1";
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".event-search");
        oThis.isLoading = false;
      }).catch(function (err) {
        console.error("Error loading events: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.isLoading = false;
      });
    },
    onTogglePastEvents() {
      this.showPastEvents = !this.showPastEvents;
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("events", "past_events", this.showPastEvents ? "1" : "0");
    },
    onFacetOptionChecked(opt) {
      if (!opt) return;
      this.selectedFacetOptions = Utils.processFacetChecked(this.selectedFacetOptions, opt);
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("events", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    isFacetOptionChecked(val) {
      return (this.selectedFacetOptions.indexOf(val) != -1);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id + "=" + opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      if (bMustReload) {
        this.search({ query: this.currentQuery, tags: "" }, true);
      }
    },
    getDay(date) {
      //this is supposed to be an ISO date
      if (!date || date.length < 10) return "";
      return date.substr(8, 2);
    },
    getMonth(date) {
      if (!date || date.length < 10) return "";
      return Utils.getMonthName(parseInt(date.substr(5, 2)));
    },
    getYear(date) {
      if (!date || date.length < 10) return "";
      return date.substr(0, 4);
    },
    formatDate(date) {
      if (!date || date.length < 10) return "";
      return `${this.getMonth(date)} ${this.getDay(date)}, ${this.getYear(date)}`;
    },
    isSameDate(date1, date2) {
      if (!date1 || !date2 || date1.length < 10 || date2.length < 10) return false;
      return date1.substring(0, 10) === date2.substring(0, 10);
    },
    downloadIcs(event) {
      /*let ics = this.constructIcs(event);
      this.downloadFile(ics, event.title);*/
      window.open(`/api/event/downloadics?id=${event.id}`)
    },
    removePunctuation(date) {
      if (!date) return "";
      return date.replace(/[\.\-:Z]/gi, '');
    },
    getLocation(event) {
      if (event.town || event.country) {
        return `${event.town || ""}${event.town ? " " : ""}${event.country || ""}`
      } else {
        return `${event.eventUrl || ""}`;
      }
    },
    constructIcs(event) {
      if (!event) return null;
      if (event.dateFrom.indexOf("T00:00") !== -1 && event.dateTo.indexOf("T00:00") !== -1) { //this is a whole day event...we just add the date part
        return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Clariant.com//EN
BEGIN:VEVENT
UID:${event.id}
DTSTART;VALUE=DATE:${Utils.getIsoDate(new Date(event.dateFrom))}
DTEND;VALUE=DATE:${this.fixEndDate(event.dateTo)}
SUMMARY:${event.title}
LOCATION:${this.getLocation(event)}
DESCRIPTION:${event.description}
END:VEVENT
END:VCALENDAR
      `;
      } else {
        return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Clariant.com//EN
BEGIN:VEVENT
UID:${event.id}
DTSTART;TZID="${Utils.offsetToTimezoneId(event.timezone, event.dateFrom)}":${this.removePunctuation(event.dateFrom)}
DTEND;TZID="${Utils.offsetToTimezoneId(event.timezone, event.dateFrom)}":${this.removePunctuation(event.dateTo)}
SUMMARY:${event.title}
LOCATION:${this.getLocation(event)}
DESCRIPTION:${event.description}
END:VEVENT
END:VCALENDAR
      `;
      }
    },
    getTimezoneBlock(timezone, date) {
      return `BEGIN:VTIMEZONE
TZID:${Utils.offsetToTimezoneId(timezone, date)}
BEGIN:STANDARD
TZOFFSETFROM:${timezone.replace(":", "")}
TZOFFSETTO:${timezone.replace(":", "")}
END:STANDARD
END:VTIMEZONE`
    },
    fixEndDate(date) {
      if (!date) return "";
      var d = new Date(date);
      var nd = new Date(date);
      nd.setDate(d.getDate() + 1);
      return Utils.getIsoDate(nd);
    },
    downloadFile(file, name) {
      if (!file) return;
      var filename = `${name || "Clariant Event"}.ics`;

      var blob = new Blob([file]);
      var link = document.createElement('a');
      if (window.navigator.msSaveOrOpenBlob) {
        link.onclick = function (e) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
      } else {
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
      }

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    },
    onApplyFilters(facetId, selectedOptions) {
      var updatedOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId))
      updatedOptions.push(...selectedOptions);
      this.selectedFacetOptions = updatedOptions
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("events", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    onResetFilters(all, facetId) {
      if (all) {
        this.selectedFacetOptions = [];
      }
      else {
        this.selectedFacetOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId));
      }
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("events", "facets", null);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width: 100%;
  justify-content: center;
}

.event-search>div {
  display: flex;
  flex-direction: row;
}


.event .event-entry {
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  padding: 32px 0;
  gap: 20px;
}

.event .event-entry:first-of-type {
  border-top: 1px solid #d9d9d9;
}

.event .event-entry .event-date {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: #777;
  text-transform: none;
}

.event .event-entry .event-coords.desktop {
  width: 150px;
  min-width: 150px;
  padding-top: 3px;
  display: flex;
  flex-direction: column;
}

.event .event-entry .event-coords.desktop>.event-dates {
  font-family: "Gotham SSm A", Arial, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #808080;
  text-transform: uppercase;
  width: 130px;
  min-width: 130px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  width: 100%;
}

.event .event-entry .event-coords.tablet {
  display: none;
  margin-bottom: 10px;
}

.event .event-entry .event-details {
  color: #323232;
  display: flex;
  cursor: pointer;
  gap: 20px;
  flex-grow:1;
}

.event .event-entry .event-details.emptycontent {
  cursor: default;
}

.event .event-entry .event-details div.event-town {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

.event .event-entry .event-details div.event-title {
  display: block;
  font-family: "Gotham SSm A", Arial, sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  margin: 10px 0 10px 0;
  word-wrap: break-word;
  color: #323232;
}

.event .event-entry .event-details .event-subtitle {
  font-family: "Gotham SSm A";
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  word-wrap: normal;
  /*for IE*/
  word-wrap: break-word;
}

.event .event-entry .event-details .event-description {
  font-family: "Gotham Narrow", sans-serif;
  word-wrap: normal;
  /*for IE*/
  word-wrap: break-word;
  font-size: 15px;
}

.event .event-entry .event-details .event-image {
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  min-width: 120px;
}

.event-search .past-events {
  margin-top: 0px;
}

.download-ics {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xNS43ODEyIDIuMjIyNjZIMTkuNzgxMkMyMC4wNDY1IDIuMjIyNjYgMjAuMzAwOCAyLjMyODAxIDIwLjQ4ODQgMi41MTU1NUMyMC42NzU5IDIuNzAzMDkgMjAuNzgxMiAyLjk1NzQ0IDIwLjc4MTIgMy4yMjI2NlYxOS4yMjI3QzIwLjc4MTIgMTkuNDg3OSAyMC42NzU5IDE5Ljc0MjIgMjAuNDg4NCAxOS45Mjk4QzIwLjMwMDggMjAuMTE3MyAyMC4wNDY1IDIwLjIyMjcgMTkuNzgxMiAyMC4yMjI3SDEuNzgxMjVDMS41MTYwMyAyMC4yMjI3IDEuMjYxNjggMjAuMTE3MyAxLjA3NDE0IDE5LjkyOThDMC44ODY2MDcgMTkuNzQyMiAwLjc4MTI1IDE5LjQ4NzkgMC43ODEyNSAxOS4yMjI3VjMuMjIyNjZDMC43ODEyNSAyLjk1NzQ0IDAuODg2NjA3IDIuNzAzMDkgMS4wNzQxNCAyLjUxNTU1QzEuMjYxNjggMi4zMjgwMSAxLjUxNjAzIDIuMjIyNjYgMS43ODEyNSAyLjIyMjY2SDUuNzgxMjVWMC4yMjI2NTZINy43ODEyNVYyLjIyMjY2SDEzLjc4MTJWMC4yMjI2NTZIMTUuNzgxMlYyLjIyMjY2Wk0xMy43ODEyIDQuMjIyNjZINy43ODEyNVY2LjIyMjY2SDUuNzgxMjVWNC4yMjI2NkgyLjc4MTI1VjguMjIyNjZIMTguNzgxMlY0LjIyMjY2SDE1Ljc4MTJWNi4yMjI2NkgxMy43ODEyVjQuMjIyNjZaTTE4Ljc4MTIgMTAuMjIyN0gyLjc4MTI1VjE4LjIyMjdIMTguNzgxMlYxMC4yMjI3WiIgZmlsbD0iIzI2NTVGRiIvPg0KPC9zdmc+DQo=);
}

.event-coords.desktop .download-ics {
  width: 20px;
  height: 20px;
  background-size: 20px;
  background-repeat: no-repeat;
  display: block;
  margin-top: 17px;
  min-width: 20px;
  cursor: pointer;
}

.event-coords.tablet .download-ics {
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  background-position: 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-left: 15px;
}

.event-entry .event-arrow {
  width: 32px;
  min-width: 32px;
  display:flex;
}

.event-entry .event-arrow a {
  width: 23px;
  height: 23px;
  display: block;
  align-self: center;
  justify-self: right;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOS4yMjgxIDcuNDk5NjhMMTMuODY0MSAyLjEzNTY4TDE1LjI3ODEgMC43MjE2OEwyMy4wNTYxIDguNDk5NjhMMTUuMjc4MSAxNi4yNzc3TDEzLjg2NDEgMTQuODYzN0wxOS4yMjgxIDkuNDk5NjhIMC41NzAzMTJWNy40OTk2OEgxOS4yMjgxWiIgZmlsbD0iIzI2NTVmZiIvPg0KPC9zdmc+DQo=);
  background-repeat: no-repeat;
  background-position: 50%;
  margin-left: 0px;
  transition: 0.3s;
}

.event-entry .event-arrow a:hover {
  margin-left: 8px;
}

@media all and (min-width: 781px) and (max-width: 960px) {

  .event-entry {
    flex-direction: column;
  }

  .event .event-entry .event-details {
    margin-left: 0;
  }

  .event .event-entry .event-coords.desktop {
    display: none;
  }

  .event .event-entry .event-coords.tablet {
    display: flex;
    flex-direction: row;
  }

}


@media all and (max-width: 780px) {

  .event-search .event {
    width: 100%;
    order: 2;
  }

  .searchrefinersbox {
    width: 100%;
    margin-left: 0;
    max-width: 100%;
    min-width: 100%;
    order: 1;
  }

  .event .event-entry .event-details {
    margin-left: 0;
  }

  .event-entry {
    flex-direction: column;
  }

  .event .event-entry .event-coords.desktop {
    display: none;
  }

  .event .event-entry .event-details .event-image {
    display: none;
  }

  .event .event-entry .event-coords.tablet {
    display: flex;
    flex-direction: row;
  }

}
</style>
